import { SpanLoading } from './span-loading';
import { cn } from '@/client/utils';
import { memo } from 'react';

export const BlockLoading = memo(() => {
  return (
    <div className={cn('mx-auto size-full text-center flex items-center justify-center py-4')}>
      <SpanLoading />
    </div>
  );
});
BlockLoading.displayName = 'BlockLoading';
